import axios from 'axios';

import {
	getStoredRoleData,
	getStoredTokenData
} from '../store/auth-context';
import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_URL;

export const contactUs = async (name, email, message) => {
	const token = getStoredTokenData().token;
	return axios.post(
		`${API_URL}/api/email-us`,
		{
			name,
			email,
			message
		},
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

//TODO ADD FAQ ENDPOINT

export const getFaqs = async () => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	return axios.get(`${API_URL}/api/${role}/faq`, {
		headers: {
			token: `${token}`
		}
	});
};
